// Referral helpers — capture and persist ?ref=CODE from URL into localStorage.
const KEY = "moodcard.ref.v1";

export function captureRefFromUrl() {
    try {
        const params = new URLSearchParams(window.location.search);
        const ref = params.get("ref");
        if (ref) {
            const cleaned = ref.toLowerCase().replace(/[^a-z0-9]/g, "").slice(0, 12);
            if (cleaned) localStorage.setItem(KEY, cleaned);
            // remove from URL bar without reload
            params.delete("ref");
            const newUrl = window.location.pathname + (params.toString() ? `?${params}` : "") + window.location.hash;
            window.history.replaceState({}, "", newUrl);
        }
    } catch { /* ignore */ }
}

export function getStoredRefCode() {
    try { return localStorage.getItem(KEY) || null; } catch { return null; }
}

export function clearStoredRefCode() {
    try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}
